var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pwd-strength" }, [
    _c("ul", { staticClass: "pwd-strength-bar" }, [
      _c("li", {
        staticClass: "point",
        class: _vm.password ? "score0" : "default"
      }),
      _c("li", {
        staticClass: "point",
        class: _vm.strength > 0 ? "score1" : "default"
      }),
      _c("li", {
        staticClass: "point",
        class: _vm.strength > 1 ? "score2" : "default"
      }),
      _c("li", {
        staticClass: "point",
        class: _vm.strength > 2 ? "score3" : "default"
      }),
      _c("li", {
        staticClass: "point",
        class: _vm.strength > 3 ? "score4" : "default"
      })
    ]),
    _vm.password
      ? _c("small", { staticClass: "pwd-strength-label" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t(`profile.edit.passwordStrength.${_vm.strength}`)) +
              " "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }